import { Box, Stack } from "@mui/material";
import LabelWithValue from "components/LabelWithValue";
import TitleWithOptions from "components/TitleWithOptions";
import { TMemberDetails } from "models/member";
import moment from "moment";

export default function PersonalInfoSection(props: {
  member: TMemberDetails;
  editCallback: Function;
}) {
  const { member, editCallback } = props;
  //console.log(`member is `, member);
  return (
    <Box className="personal-info-container">
      <TitleWithOptions title="Personal Info" edit={editCallback} />
      <Stack direction="row" gap="40px" mt="16px">
        <Stack flex={1} gap="10px">
          <LabelWithValue label="First name" value={member?.personal_details.first_name} />
          <LabelWithValue label="Last name" value={member?.personal_details.last_name} />
          <LabelWithValue
            label="Date of birth"
            value={moment(new Date(member?.personal_details.dob)).format("M/D/yyyy")}
            enableViewMode
          />
          <LabelWithValue
            label="Gender"
            value={member?.personal_details.gender === "M" ? "Male" : "Female"}
            enableViewMode
          />
          <LabelWithValue
            label="Weight"
            value={`${member?.personal_details.weight} lbs`}
            enableViewMode
          />
          <LabelWithValue
            label="Email address"
            value={member?.personal_details.email_address || `N/A`}
          />
          <LabelWithValue
            label="Primary Phone"
            value={member?.personal_details.primary_phone || `N/A`}
          />
          <LabelWithValue label="Nickname" value={member?.personal_details.nickname || `N/A`} />
          <LabelWithValue
            label="Online Username"
            value={member?.personal_details.online_username || `N/A`}
          />
          <LabelWithValue
            label="Company name "
            value={member?.personal_details.company_name || `N/A`}
          />
        </Stack>

        <Stack flex={1} gap="10px">
          <LabelWithValue
            label="Address Line 1"
            value={member?.personal_details.address_line_1 || `N/A`}
            enableViewMode
          />
          <LabelWithValue
            label="Address Line 2"
            value={member?.personal_details.address_line_2 || `N/A`}
            enableViewMode
          />
          <LabelWithValue label="City" value={member?.personal_details.city || `N/A`} />
          <LabelWithValue label="State" value={member?.personal_details.state || `N/A`} />
          <LabelWithValue label="Zip Code" value={member?.personal_details.zip_code || `N/A`} />
          <LabelWithValue label="Country" value={member?.personal_details.country || `N/A`} />
        </Stack>
      </Stack>
    </Box>
  );
}
